export default __webpack_public_path__ + "static/media/mobileEsgImage.e093990f.png";